function setLoadingTxt (state, loadingTxt) {
  state.loadingTxt = loadingTxt
}

function setMakePhotoInfo (state, obj) {
  state.makePhotoInfo = obj
}

function setDefault_price (state, obj) {
  state.default_price = obj
}

function setIsIos (state, bol) {
  state.isIos = bol
}

function setTeaminfo (state, teaminfo) {
  state.teaminfo = teaminfo
}

function setBeautyDefault (state, beauty_default) {
  state.beauty_default = beauty_default
}

function setIosUrl (state, url) {
  state.iosJssdkUrl = url
}

function setLoginState (state, val) {
  state.loginState = val
  sessionStorage.setItem('loginState', val)
}

function setOpenid (state, val) {
  state.openid = val
}

function hanleRoute (state, pathname) {
  const arr = state.pageStack
  const index = arr.findIndex((n) => n === pathname)
  if (index < 0) {
    state.pageStack.push(pathname)
    state.actiBol = true // 是push进来的
  } else if (index === arr.length - 1) {
    console.log('是懒加载路由导致路由前置守卫触发两次')
    state.actiBol = true // 是push进来的
  } else {
    state.pageStack = arr.slice(0, Number(index) + 1)
    state.actiBol = false // 是返回来的
  }
  console.log(state.actiBol ? '前进' : '后退')
}

function delPageStack (state, name) {
  const arr = state.pageStack
  const index = arr.findIndex(item => item === name)
  index > -1 && arr.splice(index, 1)
  state.pageStack = arr
}

function setDefaultColor (state, color) {
  state.defaultColor = color
}

export default {
  setLoadingTxt,
  setMakePhotoInfo,
  setDefault_price,
  setIsIos,
  setTeaminfo,
  setBeautyDefault,
  setIosUrl,
  setLoginState,
  setOpenid,
  hanleRoute,
  delPageStack,
  setDefaultColor
}
